import React from 'react';

import AuthenticationContainer from 'sharedreact/containers/AuthenticationContainer';

type Props = {
  language: string,

  postLogin?: () => void,
  postLogout?: () => void
};

class AuthenticationLauncherPage extends React.Component<Props> {
  override render (): React.ReactNode {
    const { postLogin, postLogout,
      language // eslint-disable-line no-unused-vars
    } = this.props;

    return (
      <AuthenticationContainer postLogin={postLogin} postLogout={postLogout} />
    );
  }
}

export default AuthenticationLauncherPage;
